// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"7cda09a2","381":"2f0bfe20","437":"2f0bfe20"}[chunkId] + ".chunk.css";
};